export default `use \\Firebase\\JWT\\JWT;

const PrivateKey = 'YOUR_PRIVATE_SSO_KEY';

function createCannyToken($user) {
  $userData = [
    'avatarURL' => $user['avatarURL'], // optional, but preferred
    'email' => $user['email'],
    'id' => $user['id'],
    'name' => $user['name'],
  ];
  return JWT::encode($userData, PrivateKey, 'HS256');
}`;
